import { useTexture } from '@react-three/drei';
import { Effect } from 'postprocessing';
import React, { useMemo } from 'react';
import {
  Texture,
  Uniform,
  Vector2,
  WebGLRenderer,
  WebGLRenderTarget,
} from 'three';

import { publicAssets } from 'utils/gcs';

import fragmentShader from './glsl/droplets.frag';

class DropletsEffectImpl extends Effect {
  private uTime: number = 0;

  constructor(randomnessTex: Texture) {
    const uResolution = new Vector2(window.innerWidth, window.innerHeight);

    super('DropletsEffect', fragmentShader, {
      uniforms: new Map<string, Uniform>([
        ['uRandomTexture', new Uniform(randomnessTex)],
        ['uResolution', new Uniform(uResolution)],
        ['uTime', new Uniform(0)],
      ]),
    });
  }

  update(
    renderer: WebGLRenderer,
    inputBuffer: WebGLRenderTarget,
    deltaTime?: number
  ) {
    this.uTime += deltaTime || 0;
    this.uniforms.get('uTime')!.value = this.uTime;
  }

  setSize(width: number, height: number) {
    super.setSize(width, height);

    this.uniforms.get('uResolution')!.value.set(width, height);
  }
}

export const DropletsEffect = () => {
  const randomnessTex = useTexture(publicAssets('/effects/random.jpeg'));
  const effect = useMemo(
    () => new DropletsEffectImpl(randomnessTex),
    [randomnessTex]
  );
  return <primitive object={effect} />;
};
